/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { PERMISSION_FRAGMENT } from './PermissionFragment'

export const GROUP_FRAGMENT = gql`
  fragment Group on DAIGroup {
    id
    name
    isOwner
    supervisingRole {
      id
    }
    permissions {
      ...Permission
    }
  }
  ${PERMISSION_FRAGMENT}
`
